import React from 'react';

const Bande = props => (
<svg preserveAspectRatio="none" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 1 1">
{
    props.colors.map((colr, index) => {
        let style={fill:colr, opacity:0.5}
        return <rect id={"bande_" + props.pos +"_" + index.toString()} key={"bande_" + props.pos +"_" + index.toString()} rx="0" y={index / props.colors.length} width="1" height={1 / props.colors.length} style={style}/>
    })

}
              
</svg>)

export default Bande;